import Amplify from '@aws-amplify/core'
import API, { graphqlOperation } from '@aws-amplify/api'

import apiFetch from '@wordpress/api-fetch';

// TODO use Cognito auth
const config = {
    "aws_appsync_graphqlEndpoint": "https://kputmifr55gztae23bfusq4a6e.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    // api key long expiry
    "aws_appsync_apiKey": "da2-wubu2qoffnf45k6iveuxqzrmfa",
}
Amplify.configure(config)

const subscribeDoc = /* GraphQL */ `
    subscription Subscribe($image_id: String!) {
        subscribe(image_id: $image_id) {
            image_id
            updated
        }
    }
`

export function imgwb_subscribe(image_id, next, error) {
	console.log('imgwb_subscribe', image_id);
	return API.graphql(graphqlOperation(subscribeDoc, { image_id })).subscribe({
		next: ({ provider, value }) => {
			next(value.data.subscribe, provider, value)
		},
		error: error || console.log,
	})
}
